/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnsubscribeResponse
 */
export interface UnsubscribeResponse {
    /**
     * 
     * @type {string}
     * @memberof UnsubscribeResponse
     */
    ok: string;
}

export function UnsubscribeResponseFromJSON(json: any): UnsubscribeResponse {
    return UnsubscribeResponseFromJSONTyped(json, false);
}

export function UnsubscribeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnsubscribeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ok': json['ok'],
    };
}

export function UnsubscribeResponseToJSON(value?: UnsubscribeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ok': value.ok,
    };
}


